import React from "react";
import { Box, MenuItem, Typography, Select, TextField } from "@mui/material";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

export const ESRSelectTextField = (props: ESRFieldProps) => {
	const { question_id, field_options, locked } = props;
	const [value, setValue, setLocalValue] = useRemoteField(question_id);
	const [selectValue, setSelectValue] = useRemoteField(
		`${question_id}.SELECT`,
	);
	const [textValue, setTextValue, setLocalTextValue] = useRemoteField(
		`${question_id}.TEXT`,
	);
	return (
		<>
			<Select
				id={question_id}
				aria-labelledby={question_id}
				fullWidth
				disabled={locked > 0}
				value={selectValue}
				onChange={(e) => {
					const val = e.target.value;
					setSelectValue(val, locked === -1);
					if (val === 'unknown') setTextValue('0', locked === -1);
				}}
			>
				{field_options.map((o) => {
					return (
						<MenuItem key={o} value={o}>
							{o}
						</MenuItem>
					);
				})}
			</Select>
			<Box>
				<>
					{
						selectValue !== "unknown" &&
						<TextField
						id={question_id}
						fullWidth
						disabled={locked > 0}
						value={textValue}
						onChange={(e) => setLocalTextValue(e.target.value)}
						onBlur={(e) => {
              setTextValue(e.target.value, locked === -1);
						}}
						></TextField>
					}
				</>
			</Box>
		</>
	);
};